//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      routingNumber: null,
      accountNumber: null,
      inputs: {},
      accountNumberRules: [function (value) {
        return !!value || "Account number required";
      }],
      errorMessages: null
    };
  },
  created: function created() {
    this.country = this.spec.country.toLowerCase();
    this.stripe = Stripe(this.spec.publicKey);
    this.spec.onTypeEnd = {
      action: "component/createToken"
    };
    this.registerCountry("nz", [], function () {
      return "";
    });
    this.registerCountry("au", [{
      label: "Bank State Number",
      placeholder: "110000",
      model: "",
      rules: [function (value) {
        return !!value || "Bank state number required";
      }]
    }], function () {
      return this.fields[0].model;
    });
    this.registerCountry("ca", [{
      label: "Transit",
      placeholder: "12345",
      model: "",
      rules: [function (value) {
        return !!value || "Transit number required";
      }]
    }, {
      label: "Institution",
      placeholder: "678",
      model: "",
      rules: [function (value) {
        return !!value || "Institution number required";
      }]
    }], function () {
      return "".concat(this.fields[0].model, "-").concat(this.fields[1].model);
    });
  },
  methods: {
    action_createToken: function action_createToken() {
      var _this = this;

      var token = this.$refs.token;
      this.errorMessages = null;
      this.routingNumber = this.inputs[this.country].makeRoutingNumber();

      if (this.accountNumber) {
        this.$dispatchEvent("forms/setBusy", {
          value: true
        });
        var vm = this;
        var bank = {
          country: this.spec.country,
          currency: this.spec.currency,
          account_number: this.accountNumber,
          account_holder_name: this.spec.accountHolderName,
          account_holder_type: this.spec.accountHolderType
        };

        if (this.routingNumber) {
          bank["routing_number"] = this.routingNumber;
        }

        this.stripe.createToken("bank_account", bank).then(function (response) {
          if (response.token) {
            token.value = response.token.id;
          } else {
            _this.errorMessages = [response.error.message];
            token.value = "";
          }

          vm.$dispatchEvent("forms/setBusy", {
            value: false
          });
        });
      }
    },

    /**
     * Different countries have different ways of creating routing numbers.
     * Canada, for example, requires transit numbers and institution numbers and then combined to create a routing number,
     * while New Zealand does not use a routing number.
     */
    registerCountry: function registerCountry() {
      var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var makeRoutingNumber = arguments.length > 2 ? arguments[2] : undefined;
      this.inputs[country] = {
        fields: fields,
        makeRoutingNumber: makeRoutingNumber
      };
    }
  }
};